import { FocusEvent } from 'react';
import './discount-form.scss';
import { useTranslation } from 'react-i18next';
import { analytics } from 'frontend/analytics/analytics';
import { checkCountries } from '@entities/countries';
import { Phone } from 'frontend/Components/NewCartOrder/Components/BlockForm/Fields/Phone';
import * as cartHelper from '../../../../modules/helpers/cart-helper';
import { Promocode } from './promocode/promocode';

const handleBlurField = ({ target }: FocusEvent<HTMLFormElement>) => {
  cartHelper.sendOrderField(target.name, target.value);
  if (target.name === 'phone') {
    analytics.deliveryFieldsAction(target.name as 'phone');
  }
};

function PromoPhoneForm({
  cityTextId,
  currency,
  isCheckCountries,
}: {
  cityTextId: string;
  currency: string;
  isCheckCountries: ReturnType<typeof checkCountries>;
}) {
  const { isMontenegro } = isCheckCountries;
  const { t } = useTranslation();

  const handleChangeForm = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  return (
    <form
      className="discountForm"
      onKeyDown={handleChangeForm}
      onInput={handleChangeForm}
      onPaste={handleChangeForm}
      onChange={handleChangeForm}
      onBlur={handleBlurField}
    >
      {isMontenegro ? null : (
        <Phone
          cityTextId={cityTextId}
          isCheckCountries={isCheckCountries}
          field={{
            name: 'phone',
            required: true,
            placeholder: t('locale.phone'),
            isBonusPhone: true,
          }}
        />
      )}
      <Promocode
        currency={currency}
        cityTextId={cityTextId}
        isCheckCountries={isCheckCountries}
      />
    </form>
  );
}

export default PromoPhoneForm;
